import { render, staticRenderFns } from "./term13.vue?vue&type=template&id=2f43f472"
import script from "./term13.vue?vue&type=script&lang=js"
export * from "./term13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports